import { Button, ButtonProps } from '@mui/material'
import { FC } from 'react'

export const PopoverFooterButton: FC<ButtonProps> = ({ sx, ...rest }) => {
    return (
        <Button
            variant="text"
            sx={{
                width: '50%',
                height: '32px',
                color: '#181B25',
                textWrapMode: 'nowrap',
                p: '6px 12px',
                fontWeight: 400,
                '.MuiButton-startIcon': {
                    marginRight: 0,
                },
                ...sx,
            }}
            {...rest}
        />
    )
}
